<template>
  <el-table-column
    prop="shop.name"
    sortable="custom"
    label="Üzlet"
    show-overflow-tooltip
    min-width="190"
  >
    <template slot-scope="scope">
      {{ scope.row.shop_name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'shop.name',
  };
</script>
